module.exports = __webpack_public_path__ + "static/media/cityscapes.1f402f5e.jpg";